import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-white">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="w-full h-full" style={{
            backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 1px, transparent 1px), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.08) 1px, transparent 1px)',
            backgroundSize: '60px 60px, 40px 40px',
          }}></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
            <div className="lg:col-span-2">
              <Link to="/" className="text-2xl font-heading font-bold text-white mb-4 block">
                Superbuy Spreadsheet<span className="text-accent-400">.</span>
              </Link>
              <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-sm">
                Your trusted superbuy spreadsheet partner. Curated fashion, sneakers, and streetwear resources for savvy shoppers worldwide.
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-white/40 transition-all">
                  <i className="ri-twitter-x-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-white/40 transition-all">
                  <i className="ri-instagram-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-white/40 transition-all">
                  <i className="ri-reddit-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-white/40 transition-all">
                  <i className="ri-youtube-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">Shopping</h4>
              <ul className="space-y-3">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">Guides</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/what-is-superbuy-spreadsheet/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Spreadsheet Guide
                  </Link>
                </li>
                <li>
                  <Link to="/how-to-use-superbuy-spreadsheet/" className="text-sm text-white/60 hover:text-white transition-colors">
                    How to Use
                  </Link>
                </li>
                <li>
                  <Link to="/superbuy-shipping-guide/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Shipping Guide
                  </Link>
                </li>
                <li>
                  <Link to="/superbuy-safety-guide/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Safety Tips
                  </Link>
                </li>
                <li>
                  <Link to="/superbuy-faq/" className="text-sm text-white/60 hover:text-white transition-colors">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">Legal</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Terms of Use
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              &copy; 2026 Superbuy Spreadsheet. All rights reserved. This is an independent educational resource. We are not affiliated with Superbuy.
            </p>
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors">
              Back to top &uarr;
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}